export function jsonName(key: string) {
  return function (target: any, propertyKey: string) {
    Reflect.defineMetadata("jsonName", key, target, propertyKey);
  };
}
